$('.custom-feed-videos .video-items').slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    }
   
  ]
});


function openCartDrawer() {
  setTimeout(function() {
    console.log($('.drawer.cart__drawer').hasClass('drawer--visible'));
  if (!$('.drawer.cart__drawer').hasClass('drawer--visible')) {
    $('[data-drawer-toggle="drawer-cart"]').trigger('click'); 
  }
  }, 1500)
}
 function AddToCart(id){
     $.ajax({
        type: 'POST',
        context: this,
        url: '/cart/add.js',
        data: { quantity: 1, id: id },
        dataType: 'json',
        success: function() {
           document.dispatchEvent(new CustomEvent('theme:cart:init'));
           openCartDrawer();
           
        }
      });
  }

  $(document).on("click",".product-bundle-select-btn",function(e){    
      e.preventDefault();
      var id = $(this).attr('data-id');
      AddToCart(id) 
})  ;


// free gift

let firstFreeGift = window.theme.freeGift.freeGiftAmount1;
let secondFreeGift = window.theme.freeGift.freeGiftAmount2;

let inCentsFirst = firstFreeGift * 100;
let inCentsSecond = secondFreeGift * 100;

const firstOfferPrice = Math.round(parseInt(window.theme.freeGift.freeGiftAmount1 * 100, 10) * (Shopify.currency.rate || 1));
const secondOfferPrice = Math.round(parseInt(window.theme.freeGift.freeGiftAmount2 * 100, 10) * (Shopify.currency.rate || 1));

const firstVariantId = window.theme.freeGift.firstFreeGift;
const secondVariantId = window.theme.freeGift.secondFreeGift;

// --- Helper functions ---
async function addGift(variantId) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
}

async function removeGift(itemKey) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: 0 })
  });
}

async function getCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

// --- Main free gift logic ---
async function handleFreeGifts() {
  let cart = await getCart();
  const cartTotal = cart.total_price;
  let updated = false; // track if we changed anything

  const firstGiftItem = cart.items.find(item => item.variant_id == firstVariantId);
  const secondGiftItem = cart.items.find(item => item.variant_id == secondVariantId);

  // --- First gift ---
  if (cartTotal >= firstOfferPrice && !firstGiftItem) {
    await addGift(firstVariantId);
    updated = true;
  } else if (cartTotal < firstOfferPrice && firstGiftItem) {
    await removeGift(firstGiftItem.key);
    updated = true;
  }

  // --- Second gift ---
  if (cartTotal >= secondOfferPrice && !secondGiftItem) {
    await addGift(secondVariantId);
    updated = true;
  } else if (cartTotal < secondOfferPrice && secondGiftItem) {
    await removeGift(secondGiftItem.key);
    updated = true;
  }

  // Only trigger cart reload if something changed
  if (updated) {
    document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("theme:cart:init"));
  }
}

// --- Run once and bind to cart changes ---
handleFreeGifts();
document.addEventListener("theme:cart:change", handleFreeGifts);

$('.product__subs__group input[name="selling-plan-group"]').change(function(){
   const qty = parseInt($('.product__block__quantity input[data-quantity-input]').val());
   updateButtonPrice(qty)
  //  let product_price = $(this).data('product-price');
  //  $('.btn--add-to-cart span[data-button-price]').text(product_price);
})

$('.product__subs__group input[name="selling_plan"]').change(function(){
  const qty = parseInt($('.product__block__quantity input[data-quantity-input]').val());
   updateButtonPrice(qty)
  //  let product_price = $(this).data('product-price');
  //  $('.btn--add-to-cart span[data-button-price]').text(product_price);
})
function updateButtonPrice(qty = 1) {
  console.log('checked', $('.product__subs__group input[name="selling-plan-group"]:checked').length)
  if ($('.product__subs__group input[name="selling-plan-group"]:checked').length > 0) {
    
    const newPrice = parseInt($('.product__subs__group input[name="selling-plan-group"]:checked').data('product-price-only')) * qty;
    const newPriceWithMoney = themeVendor.themeCurrency.formatMoney(newPrice, window.theme.moneyFormat);
      $('.btn--add-to-cart span[data-button-price]').text(newPriceWithMoney);
  } else {
    const newPrice = parseInt($('input[name="id"]').data('variant-price')) * qty;
    const newPriceWithMoney = themeVendor.themeCurrency.formatMoney(newPrice, window.theme.moneyFormat);
      $('.btn--add-to-cart span[data-button-price]').text(newPriceWithMoney);
  }
  // console.log('checked', $('.product__subs__group input[name="selling-plan-group"]:checked').val())
  // const newPrice = parseInt($('.product__subs__group input[name="selling-plan-group"]:checked').data('product-price-only')) * qty;
  // const newPriceWithMoney = themeVendor.themeCurrency.formatMoney(newPrice, window.theme.moneyFormat);
  //   $('.btn--add-to-cart span[data-button-price]').text(newPriceWithMoney);
  // if ($('.product__subs__group input[name="selling-plan-group"]:checked').val() !== "") {
  //   console.log('sellingPLan', $('.product__subs__group input[name="selling_plan"]:checked').data('product-price-only'));
  //   const newPrice = parseInt($('.product__subs__group input[name="selling_plan"]:checked').data('product-price-only')) * qty;
  //   const newPriceWithMoney = themeVendor.themeCurrency.formatMoney(newPrice, window.theme.moneyFormat);
  //   $('.btn--add-to-cart span[data-button-price]').text(newPriceWithMoney);
  // }
  
}

document.addEventListener('click', function(e) {

  const button = e.target.closest('.standard__cta, .section_btn a');

  if (!button) return;

  // Only run inside .our-custom-landing-pages
  if (!button.closest('.our-custom-landing-pages')) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const targetSection = button.closest('.our-custom-landing-pages').querySelector('.section-product');

  if (targetSection) {
    targetSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

});